/* eslint-disable no-var */
/* eslint-disable no-unused-vars */

function resetToDefaults(slug){
	var r = confirm('Reset to default settings?');
	if (r == true) document.location= slug+'&fluistr_reset=1';
}


( function( $ ) {
	var cstart, cend;
	var stab = 'dashboard';
	var hash = document.location.hash.replace( '#', '' );

	$( window ).on( 'hashchange', function( ) {
		hash = document.location.hash.replace( '#', '' );
		settingsShowTab( hash );
	} );

	if ( document.cookie.length > 0 ) {
		cstart = document.cookie.indexOf( 'tab=' );
		if ( cstart !== -1 ) {
			cstart = cstart + 4;
			cend = document.cookie.indexOf( ';', cstart );
			if ( cend === -1 ) {
				cend = document.cookie.length;
			}
			stab = unescape( document.cookie.substring( cstart, cend ) );
		}
	}


	if ( hash !== '' ) {
		stab = hash;
	}


	function settingsShowTab( tab ) {
		$( '.sections-container' ).addClass( 'hidden' );
		$( '#sections-' + tab ).removeClass( 'hidden' );
		$( '.nav-tab-wrapper>a' ).removeClass( 'nav-tab-active' );
		$( '.nav-tab-wrapper>a#tab-' + tab ).addClass( 'nav-tab-active' );
		document.location = '#' + tab;
	}


	$( '.sections-container' ).each( function( ) {
		var slug = $( this ).attr( 'id' ).replace( 'sections-', '' );
		var title = $( this ).attr( 'title' );
		var icon = $( this ).attr( 'data-icon' );
		var iconhtml = icon !== '' ? '<span class="dashicons-before ' + icon + '"></span>' : '';

		var $tab = $( '<a id="tab-' + slug + '" class="nav-tab">' + iconhtml + title + '</a>' );
		$tab.on( 'click', function() {
			document.cookie = 'tab=' + slug;
			settingsShowTab( slug );
		});
		$( '.nav-tab-wrapper' ).append( $tab );
	});

	$('#tab-license .dashicons-before').css({color:$('.section-part.licensed').length >0?'#46b450':'#C00'});
	


	settingsShowTab( stab );

}( jQuery ) );

